export default __webpack_public_path__ + "static/media/more.6691a521.svg";